'use strict';

(function () {
    'use strict';

    // Usage:
    // 
    // Creates:
    // 

    angular.module('app.admin').component('iotStatus', {
        require: { app: '^app' },
        template: '<div style="padding: 2em 0em;"><div class="container-fluid" translate-namespace="iot"><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><ol class="breadcrumb pull-left"><li ng-repeat="breadcrumb in $ctrl.app.breadcrumbs"><a href="{{breadcrumb.url}}">{{breadcrumb.label | translate}}</a></li><li><a ui-sref="iot" translate-namespace="iot" translate>.Urban environment monitoring</a></li><li translate-namespace="iot" translate>.Infrastructure management</li></ol><div class="pull-right"><login-widget></login-widget></div></div></div><div class="row"><div class="col-lg-6"><iot-status-table></iot-status-table></div><div class="col-lg-6"><iot-map></iot-map></div></div></div></div>',
        controller: IoTStatusController,
        controllerAs: '$ctrl'
    });

    function IoTStatusController() {
        'ngInject';

        var $ctrl = this;

        ////////////////

        $ctrl.$onInit = function () {};
        $ctrl.$onDestroy = function () {};
    }
})();